import * as Yup from 'yup';

const DomicilioSchema = Yup.object().shape({
    calle: Yup.string().required('El domicilio es requerido'),
    altura: Yup.string()
        .matches(/^[0-9]{1,}$|S\/N/i, 'Ingresá la altura correctamente.')
        .min(1, 'Ingresá al menos ${min} números')
        .max(5, 'Ingresá hasta ${max} números')
        .required('El Número es requerido'),
    codigoPostal: Yup.string()
        .matches(/^[0-9]{3,}$/, 'Ingresá un código postal sin letras.')
        .min(4, 'Ingresá al menos ${min} números')
        .max(4, 'Ingresá hasta ${max} números')
        .required('El código postal es requerido'),
});

export default DomicilioSchema;
